import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 90,
    damping: 25,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress-bar"
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 h-[2px] z-[200]"
    >
      <div className="h-full w-full bg-gradient-to-r from-[var(--k-olive)] via-[var(--k-green)] to-[var(--k-green-2)]" />
    </motion.div>
  );
}
